import * as React from 'react';
import { EligibilityProrationTabs, EmployeeCardTabs } from 'typings/enums';
import './tab.scss';

interface ITabProps {
    tab: EmployeeCardTabs | EligibilityProrationTabs;
    tabTitle: string;
    isSelected: boolean;
    onChangeTab: (tab: EmployeeCardTabs | EligibilityProrationTabs) => void;
}

export default class Tab extends React.Component<ITabProps> {
    constructor(props: ITabProps) {
        super(props);
        this.handleChangeTab = this.handleChangeTab.bind(this);
    }

    render(): React.ReactNode {
        const { tabTitle, isSelected, tab } = this.props;
        const className = `pxl-link employee-tab--${tab} tab ${isSelected ? 'active' : ''}`;
        return (
            <button
                className={className}
                onClick={this.handleChangeTab}
            >
                {tabTitle}
            </button>
        );
    }

    private handleChangeTab(): void {
        const { tab, onChangeTab } = this.props;
        onChangeTab(tab);
    }
}